import { createRoute } from "@tanstack/solid-router";
// FLAGS: la página entera se gatea por feature (org activa).
import { withFeatureGate } from "@/features/flags/feature-gate";
import { msg } from "@lingui/core/macro";
import { Filter } from "lucide-solid";
import { appRoute } from "./route";
import { useI18n } from "@/providers/i18n-provider";
import { PageContainer } from "@/components/ui/page-container";
import { PageHeader } from "@/components/ui/page-header";
import { CrmTabs } from "@/features/crm/crm-tabs";
import { SegmentBuilder } from "@/features/crm/segment-builder";

function CrmSegmentsPage() {
  const { t } = useI18n();
  return (
    <PageContainer maxWidth="6xl">
      <PageHeader
        title={t(msg`Segments`)}
        description={t(msg`Dynamic audiences for campaigns`)}
        icon={Filter}
        backTo="/crm"
      />
      <div class="mt-4">
        <CrmTabs />
        <SegmentBuilder />
      </div>
    </PageContainer>
  );
}

export const crmSegmentsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/crm/segments",
  component: withFeatureGate("crm.leads", CrmSegmentsPage),
});
